import { render, staticRenderFns } from "./ChooserModal.vue?vue&type=template&id=b2b32394"
import script from "./ChooserModal.vue?vue&type=script&lang=js"
export * from "./ChooserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports